import React from 'react';

import './photographer.css';

const PhotographerComponent = ({
  shouldRender,
  name,
  membership,
  prices,
  photos,
  positions,
  error,
  born,
  died,
  gender,
  place,
}) => (
  <section className="o-photographer">
    {shouldRender && (
      <div>
        <h1 className="a-photographer-header f3 db">{name}</h1>
        <ul>
          {place && <li>Sted: {place}</li>}
          <li>Født: {born}</li>
          {died && <li>Død: {died}</li>}
          <li>Medlem fra: {membership.from}</li>
          {membership.to && <li>Medlem til: {membership.to}</li>}
        </ul>
        {!!prices.length && (
          <div>
            <span className="a-photographer-header f3 db">Priser</span>
            {prices.map(priceYear => (
              <div key={priceYear.year}>
                <h3 className="mb1">{priceYear.year}</h3>
                <ul className="mt0 pl4">
                  {priceYear.result.map((result, i) => (
                    <li key={i}>{result}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
        {!!positions.length && (
          <div>
            <span className="a-photographer-header f3 db">Posisjoner</span>
            {positions.map((position, i) => (
              <div key={i}>
                <h3 className="mb1">{position.title}</h3>
                <ul className="mt0 pl4">
                  {position.period.map((result, i) => (
                    <li key={i}>{result}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    )}
  </section>
);

export default PhotographerComponent;



// WEBPACK FOOTER //
// ./src/pages/PhotographerComponent.js